<script lang="ts" setup>
import type { PurpleFAQ } from '~~/server/api/faq/index'

export interface PagesFaqCategories {
    faq: PurpleFAQ[]
    categorySlug: string
}
const props = defineProps<PagesFaqCategories>()
</script>
<template>
  <ul>
    <li
      v-for="(link, index2) in props.faq"
      :key="`faqcdil-${index2}`"
      class="mb-4"
    >
      <VNuxtLink
        :to="{
          name: 'faq-detail',
          params: {
            id: link.slug,
            category: categorySlug,
          },
        }"
        class="fs-md-bigger"
        :label="link.question"
      >
        {{ link.question }}
      </VNuxtLink>
    </li>
  </ul>
</template>
